import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";
import { useQuery } from "@tanstack/react-query";
import React from "react";
import { IFormValues } from "../../../../types";
import { InvoiceType, ReactQueryKey } from "../../../../../../types";
import { getMobilePrefixes } from "../../../../../../api/services";
import { FormAutocomplete } from "../../../../../../components/fields";

const MobilePrefixField = () => {
    const { t } = useTranslation('booking');

    const invoiceType = useWatch<IFormValues, "invoice.type">({
        name: 'invoice.type'
    });

    const mobilePrefixesQuery = useQuery({
        queryKey: [ReactQueryKey.MobilePrefixes],
        queryFn: getMobilePrefixes,
        refetchOnMount: false
    });

    return (
        <FormAutocomplete<IFormValues>
            name="invoice.mobilePrefix"
            label={t('label.prefix') + (invoiceType !== InvoiceType.PERSON ? '*' : '')}
            options={mobilePrefixesQuery.data ?? []}
            isOptionEqualToValue={(option, value) => option.country === value.country}
            getOptionLabel={(option) => ('+' + option.prefix + ` (${option.country})`)}
            disabled={true}
        />
    )
}

export default MobilePrefixField;
